import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import cn from 'classnames';

import logo from 'public/images/logo.png';

import { useCompanyBranding } from 'resources/company/hooks';

import styles from './styles.module.scss';

// TODO: think about beautiful transition while branding loading
const UnauthorizedLayout = ({ children, pageContentOffset }) => {
  const router = useRouter();

  const {
    companyBackground,
    companyLogoUrl,
  } = useCompanyBranding({ realtorId: router.query?.id });

  return (
    <div className={styles.wrapper}>
      <header
        className={cn(styles.header, { [styles.withBranding]: companyLogoUrl })}
        style={{ backgroundColor: companyBackground }}
      >
        <img
          src={companyLogoUrl || logo}
          className={cn(styles.logo, { [styles.withBranding]: companyLogoUrl })}
          alt="logo"
        />
      </header>

      <main className={cn(styles.content, { [styles[pageContentOffset]]: pageContentOffset })}>{children}</main>
    </div>
  );
};

UnauthorizedLayout.propTypes = {
  children: PropTypes.node.isRequired,
  pageContentOffset: PropTypes.string,
};

UnauthorizedLayout.defaultProps = {
  pageContentOffset: 'defaultOffset',
};

export default UnauthorizedLayout;
